import { render, staticRenderFns } from "./FilterRegion.vue?vue&type=template&id=67bc94a6&"
import script from "./FilterRegion.vue?vue&type=script&lang=js&"
export * from "./FilterRegion.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./FilterRegion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports